import { PluginObject } from "vue/types/plugin";

import { tryCatchResponse } from "@/interfaces/interfaces";
import { constant } from "./ConstantPlugin";

export class Utility {
  async tryCatch<T>(promise: Promise<T>): Promise<tryCatchResponse<T>> {
    try {
      const response = await promise;
      return {
        response,
        error: null,
      };
    } catch (error) {
      return {
        response: null,
        error,
      };
    }
  }

  percentage(value: number, total: number) {
    return Math.round((value / total) * 100);
  }

  fixImageUrl(url: string, thumbnail = false) {
    const image_base_url = constant.FILE_STORAGE_URL;
    const image = url.split("/")[url.split("/").length - 1];
    if (!image) return null;
    return encodeURI(
      `${image_base_url}${thumbnail ? "thumbnails/" : ""}${image}`
    );
  }

  pad(num: number, size: number) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
  }

  isVotingDay() {
    const startDay = new Date(2021, 8, 5, 23, 59, 0);
    const today = new Date();

    return true;
    // return startDay.getTime() <= today.getTime();
  }

  isVotingStarted() {
    const votingStarts = new Date(2021, 8, 7, 17, 59, 0);
    const today = new Date();

    return true;

    // return votingStarts.getTime() <= today.getTime();
  }

  closeVoting() {
    const closingDay = new Date(2021, 8, 16, 0, 0, 0);
    const today = new Date();
    return closingDay.getTime() <= today.getTime();
  }

  isOnBottom(threshHold = 0) {
    return (
      Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      ) +
        window.innerHeight >=
      document.documentElement.offsetHeight
    );
  }
}

export const utility = new Utility();

export const UtilityPlugin: PluginObject<any> = {
  install: (vue, options) => {
    vue.prototype.$utility = utility;
  },
};
